module.exports = __webpack_public_path__ + "media/images/search-3aef0d46.png";